import { Navigate } from "react-router-dom"
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Authentication/login";
import Logout from "../pages/Authentication/Logout";
import UserProfile from "../pages/Authentication/Profile";
import PagesMaintenance from "pages/Utility/pages-maintenance";
import Pages404 from "pages/Utility/pages-404";
import Pages500 from "pages/Utility/pages-500";
import Categories from "pages/Categories/Listing";
import CreateCategories from "pages/Categories/Create";
import EditCategory from "pages/Categories/EditCategory";
import Products from "pages/Products/Manage Products/Products";
import CreateProduct from "pages/Products/Manage Products/CreateProduct";
import DeletedProducts from "pages/Products/Deleted Products/DeletedProducts";
import Package from "pages/Packages/Package";
import Bookings from "pages/Bookings/Bookings/Bookings";
import DeletedBookings from "pages/Bookings/DeletedBookings";
import Discounts from "pages/Bookings/Discounts/Discounts";
import Customers from "pages/Customers/Customers";
import Blacklist from "pages/Customers/Blacklist";
import Inquiries from "pages/Customer Support/Inquiries";
import CreatePackage from "pages/Packages/CreatePackage";
import InvoiceListing from "pages/Payment/InvoiceListing";
import RentalDocs from "pages/Documents/Rental";
import General from "pages/Settings/General/General";
import Holidays from "pages/Settings/Holidays/Holidays";
import BookingQuestion from "pages/Settings/Booking Questions/BookingQuestion";
import DeliveryPricing from "pages/Settings/Postcodes Pricing/DeliveryPricing";
import Users from "pages/Users/Users";
import SmsTemplate from "pages/Automation/SmsTemplate";
import EmailTemplate from "pages/Automation/EmailTemplate";
// import Home from "pages/Website Pages/Home";
import EditProduct from "pages/Products/Manage Products/Edit/EditProducts";
import CreateDiscountCode from "pages/Bookings/Discounts/CreateDiscountCode";
import EditDiscountCodes from "pages/Bookings/Discounts/EditDiscountCodes";
import AddBookingQuestions from "pages/Settings/Booking Questions/AddBookingQuestions";
import EditBookingQuestions from "pages/Settings/Booking Questions/EditBookingQuestions";
import ChangePassword from "pages/Authentication/ChangePassword";
import ForgetPasswordPage from "pages/Authentication/ForgotPassword";
import ResetPassword from "pages/Authentication/ResetPassword";
import CreateBookings from "pages/Bookings/Bookings/Edit and Create/CreateBookings";
import EditBooking from "pages/Bookings/Bookings/Edit and Create/EditBooking";
import AddHoliday from "pages/Settings/Holidays/AddHoliday";
import EditHoliday from "pages/Settings/Holidays/EditHoliday";
import InvoiceDetail from "pages/Payment/InvoiceDetail";
import Calender from "pages/Bookings/Calendar/Calendar";
import Locations from "pages/Website Pages/Locations/Locations";
import Pages from "pages/Website Pages/Locations Pages/Pages";
import AddPage from "pages/Website Pages/Locations Pages/AddPage";
import EditPage from "pages/Website Pages/Locations Pages/EditPage";
import Delivery from "pages/Bookings/Bookings/Delivery";
import Collection from "pages/Bookings/Bookings/Collection";
import Privacy from "pages/Documents/Privacy";
import About from "pages/Website Pages/About";
import Contact from "pages/Website Pages/Contact";
import GeneralPage from "pages/Website Pages/General Pages/Pages";
import AddGeneralPage from "pages/Website Pages/General Pages/AddPage";
import EditGeneralPage from "pages/Website Pages/General Pages/EditPage";
import Testimonials from "pages/Website Pages/Testimonials/Testimonials";
import AddTestimonials from "pages/Website Pages/Testimonials/AddTestimonials";
import Callback from "pages/Customer Support/Callbacks";
import AddUser from "pages/Users/AddUser";
import EditUser from "pages/Users/EditUser";
import { PERMISSIONS } from "./Permissions";
import AccessDenied from "pages/Utility/access-denied";
import NewsLetter from "pages/Customers/NewsLetter";
import GroupsListing from "pages/Packages/Groups/GroupsListing";
import EditPackage from "pages/Packages/EditPackage";
import UploadCSV from "pages/Products/Manage Products/UploadCSV";
import UploadBookingsCSV from "pages/Bookings/Bookings/BookingCSV";
import Home from "pages/Website Pages/Home";
interface RouteConfig {
  path: string;
  component: React.ReactNode;
  permission?: string[];
  exact?: boolean;
}

const authProtectedRoutes : RouteConfig[] = [
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },

  { path: "/dashboard", component: <Dashboard />, permission: [PERMISSIONS.DASHBOARD],  },
  
  { path: "/products", component: <Products />, permission: [PERMISSIONS.PRODUCTS.VIEW, PERMISSIONS.PRODUCTS.DELETE] },
  { path: "/products/create", component: <CreateProduct />, permission: [PERMISSIONS.PRODUCTS.CREATE] },
  { path: "/products/create/bulk", component: <UploadCSV />, permission: [PERMISSIONS.PRODUCTS.CREATE] },
  { path: "/products/:id/edit", component: <EditProduct />, permission: [PERMISSIONS.PRODUCTS.EDIT] },

  { path: "/products/deleted", component: <DeletedProducts />, permission: [PERMISSIONS.PRODUCTS.VIEW_DELETED, PERMISSIONS.PRODUCTS.RESTORE_DELETED] },

  { path: "/categories", component: <Categories />, permission: [PERMISSIONS.CATEGORIES.VIEW, PERMISSIONS.CATEGORIES.DELETE] },
  { path: "/categories/create", component: <CreateCategories />,  permission: [PERMISSIONS.CATEGORIES.CREATE] },
  { path: "/categories/:id/edit", component: <EditCategory />, permission: [PERMISSIONS.CATEGORIES.EDIT] },

  { path: "/packages", component: <Package />, permission: [PERMISSIONS.PACKAGES.VIEW, PERMISSIONS.PACKAGES.DELETE] },
  { path: "/packages/create", component: <CreatePackage />, permission: [PERMISSIONS.PACKAGES.CREATE] },
  { path: "/packages/:id/edit", component: <EditPackage />, permission: [PERMISSIONS.PACKAGES.EDIT] },

  { path: "/packages-groups", component: <GroupsListing />, permission: [PERMISSIONS.PACKAGES.VIEW] },

  { path: "/bookings", component: <Bookings />, permission: [PERMISSIONS.BOOKINGS.VIEW, PERMISSIONS.BOOKINGS.DELETE] },
  { path: "/bookings/create", component: <CreateBookings />, permission: [PERMISSIONS.BOOKINGS.CREATE] },
  { path: "/bookings/create/bulk", component: <UploadBookingsCSV />, permission: [PERMISSIONS.BOOKINGS.CREATE] },
  { path: "/bookings/:id/edit", component: <EditBooking />, permission: [PERMISSIONS.BOOKINGS.EDIT] },
  { path: "/bookings/:id/delivery", component: <Delivery />, permission: [PERMISSIONS.BOOKINGS.DELIVERY] },
  { path: "/bookings/:id/collection", component: <Collection />, permission: [PERMISSIONS.BOOKINGS.COLLECTION] },

  { path: "/calendar", component: <Calender />, permission: [PERMISSIONS.BOOKINGS.CALENDAR] },
  { path: "/deleted-bookings", component: <DeletedBookings />, permission: [PERMISSIONS.BOOKINGS.VIEW_DELETED, PERMISSIONS.BOOKINGS.RESTORE_DELETED] },

  { path: "/discounts", component: <Discounts />, permission: [PERMISSIONS.DISCOUNTS.VIEW, PERMISSIONS.DISCOUNTS.DELETE] },
  { path: "/discounts/create", component: <CreateDiscountCode />, permission: [PERMISSIONS.DISCOUNTS.CREATE] },
  { path: "/discounts/:id/edit", component: <EditDiscountCodes /> , permission: [PERMISSIONS.DISCOUNTS.EDIT] },

  { path: "/customers", component: <Customers />, permission: [PERMISSIONS.CUSTOMERS.VIEW, PERMISSIONS.CUSTOMERS.DELETE] },
  { path: "/customers/blacklist", component: <Blacklist />, permission: [PERMISSIONS.CUSTOMERS.VIEW_BLACKLIST, PERMISSIONS.CUSTOMERS.DELETE_BLACKLIST] },
  { path: "/customers/inquiries", component: <Inquiries />, permission: [PERMISSIONS.CUSTOMERS.VIEW_INQUIRIES, PERMISSIONS.CUSTOMERS.UPDATE_INQUIRIES] },
  { path: "/customers/callback", component: <Callback />, permission: [PERMISSIONS.CUSTOMERS.VIEW_CALLBACKS, PERMISSIONS.CUSTOMERS.UPDATE_CALLBACKS] },
  { path: "/customers/newsletters", component: <NewsLetter />, permission: [PERMISSIONS.CUSTOMERS.VIEW_NEWSLETTER, PERMISSIONS.CUSTOMERS.UPDATE_NEWSLETTER] },

  { path: "/payments", component: <InvoiceListing />, permission: [PERMISSIONS.BOOKINGS.VIEW] },
  { path: "/payments/:id", component: <InvoiceDetail />, permission: [PERMISSIONS.BOOKINGS.VIEW] },

  // System & Settings
  { path: "/pages/testimonials", component: <Testimonials /> , permission: [PERMISSIONS.WEB_PAGES.MANAGE] },
  { path: "/pages/testimonials/create", component: <AddTestimonials />, permission: [PERMISSIONS.WEB_PAGES.MANAGE] },

  { path: "/pages/home", component: <Home />, permission: [PERMISSIONS.WEB_PAGES.MANAGE] },

  { path: "/location", component: <Locations />, permission: [PERMISSIONS.WEB_PAGES.MANAGE] },
  { path: "/pages/locations", component: <Pages />, permission: [PERMISSIONS.WEB_PAGES.MANAGE] },
  { path: "/pages/locations/create", component: <AddPage /> ,permission: [PERMISSIONS.WEB_PAGES.MANAGE] },
  { path: "/pages/locations/:id/edit", component: <EditPage /> ,permission: [PERMISSIONS.WEB_PAGES.MANAGE] },

  { path: "/pages/venue", component: <GeneralPage type_id="2" title='Venue Pages'/>, permission: [PERMISSIONS.WEB_PAGES.MANAGE]  },
  { path: "/pages/venue/create", component: <AddGeneralPage type_id={2} title='Venue Pages' link='/pages/venue'/>, permission: [PERMISSIONS.WEB_PAGES.MANAGE]  },
  { path: "/pages/venue/:id/edit", component: <EditGeneralPage type_id={2} title='Venue Pages' link='/pages/venue'/> ,permission: [PERMISSIONS.WEB_PAGES.MANAGE] },

  { path: "/pages/news", component: <GeneralPage type_id="9" title='News Pages'/>, permission: [PERMISSIONS.WEB_PAGES.MANAGE]  },
  { path: "/pages/news/create", component: <AddGeneralPage type_id={9} title='News Pages' link='/pages/news'/> ,permission: [PERMISSIONS.WEB_PAGES.MANAGE]  },
  { path: "/pages/news/:id/edit", component: <EditGeneralPage type_id={9} title='News Pages' link='/pages/news'/>, permission: [PERMISSIONS.WEB_PAGES.MANAGE] },

  { path: "/pages/service", component: <GeneralPage type_id="10" title='Service Pages'/>, permission: [PERMISSIONS.WEB_PAGES.MANAGE]  },
  { path: "/pages/service/create", component: <AddGeneralPage type_id={10} title='Service Pages' link='/pages/service'/>, permission: [PERMISSIONS.WEB_PAGES.MANAGE]  },
  { path: "/pages/service/:id/edit", component: <EditGeneralPage type_id={10} title='Service Pages' link='/pages/service'/>, permission: [PERMISSIONS.WEB_PAGES.MANAGE] },

  { path: "/pages/blogs", component: <GeneralPage type_id="8" title='Blog Pages'/>, permission: [PERMISSIONS.WEB_PAGES.MANAGE] },
  { path: "/pages/blogs/create", component: <AddGeneralPage type_id={8} title='Blog Pages' link='/pages/blogs'/>, permission: [PERMISSIONS.WEB_PAGES.MANAGE] },
  { path: "/pages/blogs/:id/edit", component: <EditGeneralPage type_id={8} title='Blog Pages' link='/pages/blogs'/>, permission: [PERMISSIONS.WEB_PAGES.MANAGE] },

  { path: "/pages/about", component: <About />, permission: [PERMISSIONS.WEB_PAGES.MANAGE] },
  { path: "/pages/contact", component: <Contact /> , permission: [PERMISSIONS.WEB_PAGES.MANAGE] },

  { path: "/users", component: <Users />, permission: [PERMISSIONS.USERS.VIEW, PERMISSIONS.USERS.DELETE] },
  { path: "/users/create", component: <AddUser /> , permission: [PERMISSIONS.USERS.CREATE] },
  { path: "/users/:id/edit", component: <EditUser />, permission: [PERMISSIONS.USERS.EDIT] },

  { path: "/rental-document", component: <RentalDocs />, permission: [PERMISSIONS.WEB_PAGES.MANAGE] },
  { path: "/privacy-document", component: <Privacy />, permission: [PERMISSIONS.WEB_PAGES.MANAGE] },

  { path: "/general", component: <General />, permission: [PERMISSIONS.SETTINGS.GENERAL] },
  { path: "/delivery-pricing", component: <DeliveryPricing />, permission: [PERMISSIONS.SETTINGS.DELIVERY] },

  { path: "/holidays", component: <Holidays />, permission: [PERMISSIONS.HOLIDAYS.VIEW, PERMISSIONS.HOLIDAYS.DELETE] },
  { path: "/holidays/create", component: <AddHoliday />, permission: [PERMISSIONS.HOLIDAYS.CREATE] },
  { path: "/holidays/:id/edit", component: <EditHoliday />, permission: [PERMISSIONS.HOLIDAYS.EDIT] },
  
  { path: "/booking-questions", component: <BookingQuestion />, permission: [PERMISSIONS.BOOKING_QUESTIONS.VIEW, PERMISSIONS.BOOKING_QUESTIONS.DELETE] },
  { path: "/booking-questions/create", component: <AddBookingQuestions /> , permission: [PERMISSIONS.BOOKING_QUESTIONS.CREATE] },
  { path: "/booking-questions/:id/edit", component: <EditBookingQuestions />, permission: [PERMISSIONS.BOOKING_QUESTIONS.EDIT] },

  { path: "/automation/sms-template", component: <SmsTemplate />, permission: [PERMISSIONS.AUTOMATION.SMS_TEMPLATES] },
  { path: "/automation/email-template", component: <EmailTemplate />, permission: [PERMISSIONS.AUTOMATION.EMAIL_TEMPLATES] },

  // user profile and password
  { path: "/profile", component: <UserProfile /> },
  { path: "/change-password", component: <ChangePassword /> },

];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/reset_password", component: <ResetPassword />}, 

  { path: "/pages-maintenance", component: <PagesMaintenance /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/access-denied", component: <AccessDenied /> },
  { path: "/*", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },
]
export { authProtectedRoutes, publicRoutes };

